(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/square-envelope/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/square-envelope/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
let getCallToAction;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  getCallToAction = trinidad.components.require('banner_common', 'banner-helpers').getCallToAction;
} else {
  getCallToAction = svs.banner_common.banner_helpers.getCallToAction;
}

async function renderComponent(model, widgetInfo, position, req, res) {
  var _res$locals, _svs$core, _model$contentType, _model$images, _model$images2, _model$images3;
  let isAdmin;
  let hbsCompiled;
  let format;
  const features = isServer ? (res === null || res === void 0 || (_res$locals = res.locals) === null || _res$locals === void 0 ? void 0 : _res$locals.features) || [] : ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.features) || [];
  if (isServer) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-square_envelope-square_envelope'];
    format = trinidad.components.require('utils', 'format').api;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
  } else {
    hbsCompiled = svs.banner_layouts.square_envelope.templates.square_envelope;
    format = svs.utils.format;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
  }
  const title = model.title,
    callToActions = model.callToActions,
    layoutConfig = model.layoutConfig,
    layoutType = model.layoutType,
    bannerId = model.id,
    targetOffer = model.targetOffer;
  const trackingStringTitle = format.safeString(title);
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  const actionViewConfig = {
    block: true,
    focus: true
  };
  const callToAction = getCallToAction(callToActions[0], actionViewConfig);
  const crm = targetOffer || '';
  const trackingString = "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(layoutType, "/").concat(trackingStringTitle);
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    bannerId,
    bgImage: (_model$images = model.images) === null || _model$images === void 0 ? void 0 : _model$images.filter(img => img.name === 'backgroundImage' || img.typeName === 'backgroundImage')[0],
    focusImage: (_model$images2 = model.images) === null || _model$images2 === void 0 ? void 0 : _model$images2.filter(img => img.name === 'focusImage' || img.typeName === 'focusImage')[0],
    fgImage: (_model$images3 = model.images) === null || _model$images3 === void 0 ? void 0 : _model$images3.filter(img => img.name === 'foregroundImage' || img.typeName === 'foregroundImage')[0],
    callToAction,
    contentType,
    crm,
    features,
    isAdmin,
    trackingString
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.square_envelope = {
    renderComponent
  };
}

 })(window);